import { useEffect } from "react";

const SEO = ({ title, description, keywords, path }) => {
  useEffect(() => {
    const base = "Fixedraws";
    document.title = title ? `${title} | ${base}` : `${base} - Expert Football Pool Draw Predictions`;

    const setMeta = (name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[name="${name}"]`) || document.querySelector(`meta[property="${name}"]`);
      if (el) { el.setAttribute("content", content); }
    };

    if (description) {
      setMeta("description", description);
      setMeta("og:description", description);
      setMeta("twitter:description", description);
    }
    if (title) {
      setMeta("og:title", `${title} | ${base}`);
      setMeta("twitter:title", `${title} | ${base}`);
    }
    if (path) {
      const url = `https://fixedraws.com${path}`;
      setMeta("og:url", url);
      setMeta("twitter:url", url);
      const canon = document.querySelector("link[rel='canonical']");
      if (canon) canon.setAttribute("href", url);
    }
    if (keywords) setMeta("keywords", keywords);
  }, [title, description, keywords, path]);

  return null;
};

export default SEO;
